import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Upload } from 'antd';

import { addAttachment, removeAttachment, clearGeojson } from 'modules/userrequestComment';
import ModalDrawMap from 'components/ModalDrawMap/ModalDrawMap';
import CommentItemAttachments from 'components/Comments/CommentItemAttachments';
import withAuthentication from 'hoc/authentication';
import { canCommentInternal } from 'helpers/permissionsHelpers';


import styles from 'components/UploadAttachment/UploadAttachment.module.scss';

class UploadAttachment extends React.Component {
  state = {
    showDrawMap: false,
  };

  onRemove = file => {
    this.props.removeAttachment(file.uid);
  }

  beforeUpload = file => {
    this.props.addAttachment(file);
    return false;
  }

  closeModal = () => {
    this.setState({ showDrawMap: false });
  }

  handleRemoveGeojson = () => {
    this.props.clearGeojson();
  }

  render () {
    const { showDrawMap } = this.state;
    const { file, geojson, user, intersections, author } = this.props;
    const { permissions } = user;
    const canEdit = canCommentInternal(permissions, true);

    return (
      <div>
        <div>
          {canEdit && (
            <Button
              size="small"
              style={{ marginRight: 12 }}
              onClick={() => this.setState({ showDrawMap: !showDrawMap })}
              icon="environment-o"
            >
              {geojson.features.length ? 'Rééditer un parcours' : 'Proposer un parcours'}
            </Button>
          )}
          <Upload
            multiple={false}
            onRemove={this.onRemove}
            beforeUpload={this.beforeUpload}
            fileList={file && [file]}
          >
            <Button size="small" icon="upload">
              Pièce jointe
            </Button>
          </Upload>
        </div>
        {(!file && !geojson.features.length) && (
          <p className={styles.info}>
            Une seule pièce jointe par envoi.
          </p>
        )}
        {!!geojson.features.length && (
          <CommentItemAttachments
            isLink={false}
            geojson={geojson}
            editable
            is_internal
            handleRemoveGeojson={this.handleRemoveGeojson}
          />
        )}
        {showDrawMap && (
          <ModalDrawMap
            author={author}
            visible={showDrawMap}
            closeModal={this.closeModal}
            geojson={geojson}
            editable={canEdit}
            firstDraw
            isInternal
            intersections={intersections}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  file: state.userrequestComment.attachment,
  geojson: state.userrequestComment.geojson,
  intersections: state.userrequestComment.intersections,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  addAttachment,
  removeAttachment,
  clearGeojson,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withAuthentication(UploadAttachment));



// WEBPACK FOOTER //
// ./src/components/UploadAttachment/UploadAttachment.js